import "./Main.css";
import { useEffect, useRef, useState } from "react";
import { motion, useInView, AnimatePresence } from "framer-motion";
import { useSectionScroll } from "../../hooks/useSectionScroll";

const imagens = [
  "/imagens/body-um/imagens-carrossel/5.png",
  "/imagens/body-um/imagens-carrossel/6.png",
  "/imagens/body-um/imagens-carrossel/7.png",
  "/imagens/body-um/imagens-carrossel/8.png",
  "/imagens/body-um/imagens-carrossel/9.png",
  "/imagens/body-um/imagens-carrossel/10.png"
];

export const Main = ({ currentRef, nextRef, prevRef, abrirModal, scrollToSolicitaRef }) => {
  const [index, setIndex] = useState(0);
  const [mostrarConteudo, setMostrarConteudo] = useState(true);
  const conteudoRef = useRef(null);
  const [abrirSaibaMais, setAbrirSaibaMais] = useState(false)

  const isInView = useInView(conteudoRef, { once: false, margin: "-30% 0px -30% 0px" });

  const variants = {
    visible: { opacity: 1, y: 0, scale: 1, transition: { duration: 0.8, ease: "easeOut" } },
    hidden: { opacity: 0, y: 50, scale: 0.7 }
  };

  const exitVariants = {
    exit: { opacity: 0, y: -30, transition: { duration: 0.5 } }
  };

  useEffect(() => {
    const intervalo = setInterval(() => {
      const proximo = (index + 1) % imagens.length;
      const img = new Image();
      img.src = imagens[proximo];
      img.onload = () => setIndex(proximo);
    }, 5000);

    return () => clearInterval(intervalo);
  }, [index]);

  useEffect(() => {
    if (currentRef.current) {
      currentRef.current.style.backgroundImage = `url(${imagens[index]})`;
    }
  }, [index, currentRef]);

  useSectionScroll({
    currentRef,
    nextRef,
    prevRef,
    disabled: abrirSaibaMais || abrirModal,
  });


  const aoClicarSaibaMais = () => {
    setTimeout(() => setAbrirSaibaMais(true), 100)
  };

  const fecharSaibaMais = () => {
    setTimeout(() => setAbrirSaibaMais(false), 100)
    setMostrarConteudo(true);
  }

  const scrollParaSolicitar = () => {
    if (scrollToSolicitaRef?.current) {
      scrollToSolicitaRef.current.scrollIntoView({ behavior: "smooth" })
    }
  }

  useEffect(() => {
    document.body.style.overflow = abrirSaibaMais ? "hidden" : "auto";
  }, [abrirSaibaMais]);

  return (
    <main className="container-main" ref={currentRef}>
      <AnimatePresence>
        {mostrarConteudo && (
          <div className="conteudo-faca-parte" ref={conteudoRef}>
            <motion.div
              className="logo-faca-parte-wrapper"
              variants={variants}
              initial="hidden"
              animate={isInView ? "visible" : "hidden"}
              exit="exit"
              {...exitVariants}
            >
              <img
                className="logo-faca-parte"
                src="/imagens/body-um/faca-parte.png"
                alt="Faça parte"
              />

            </motion.div>

            <motion.div
              className="botoes-faca-parte"
              variants={variants}
              initial="hidden"
              animate={isInView ? "visible" : "hidden"}
              exit="exit"
              {...exitVariants}
            >
              <button className="botao" type="button" onClick={aoClicarSaibaMais}>
                SAIBA MAIS
              </button>
              <button className="botao" type="button" onClick={scrollParaSolicitar}>SOLICITE</button>
            </motion.div>
          </div>
        )}
      </AnimatePresence>
      <div>
        {abrirSaibaMais && (
          <div className="saiba-mais">

            <button
              className="botao-fechar-saiba-mais"
              onClick={fecharSaibaMais}
            >
              &times;
            </button>

            <h2 className="titulo-saiba-mais">FACILITANDO SOLUÇÕES, FORTALECENDO NOSSA CIDADE!</h2>
            <p className="texto-saiba-mais">
              O <strong>SOLICITA SANTA CRUZ</strong> É A PLATAFORMA QUE CONECTA A POPULAÇÃO ÀS SOLUÇÕES.
              <br></br>
              NOSSO OBJETIVO É FACILITAR A COMUNICAÇÃO ENTRE OS CIDADÃOS E OS ÓRGÃOS RESPONSÁVEIS, PERMITINDO QUE QUALQUER PESSOA REGISTRE SOLICITAÇÕES PARA RESOLVER PROBLEMAS EM SUA COMUNIDADE.
              <br></br>
              <br></br>
              A PLATAFORMA PERMITE ACOMPANHAR O ANDAMENTO DE CADA PEDIDO, GARANTINDO MAIS TRANSPARÊNCIA E EFICIÊNCIA NA RESOLUÇÃO DAS DEMANDAS.
              <br></br>
              <br></br>
              JUNTOS, PODEMOS CONSTRUIR UMA CIDADE MELHOR! FAÇA SUA SOLICITAÇÃO E CONTRIBUA PARA UMA SANTA CRUZ MAIS ORGANIZADA E EFICIENTE.
            </p>
          </div>
        )}
      </div>
    </main>
  );
};
